#import "@/apollo/fragments/ComputedDeliverableStatus.gql"

mutation SetComputedDeliverablesVisibleTo(
    $campaignId: ID!
    $libraryFilters: InputLibraryFilters
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $visibleTo: [ID]!
) {
    setComputedDeliverablesVisibility(
        campaignId: $campaignId
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
        visibleTo: $visibleTo
    ) {
        ...ComputedDeliverableStatus
    }
}
